import { useContext } from 'react'
import {
  FunctionalDiagramEditContext,
  SET_SELECTED_SECTION_DATA,
  SET_SELECTED_SECTION_RECORD_DATA,
} from './context/context'
import { ProgresSpinner } from '../../../common/ProgresSpinner'
import { SearchCircuitHeader, SearchCircuitRows } from './SearchCircuitHeader'
import SearchResultRows from './SearchResultRows'
import { getRequest } from '../../../../services/base'
import { useParams } from 'react-router-dom'
import NoDataFound from '../../../common/NoDataFound'
import { NavContext } from '../../../../context/global_context'

const SearchResult = (props) => {
  const { vehicle } = useParams()

  const [navState, navDispatch] = useContext(NavContext)
  const [state, dispatch] = useContext(FunctionalDiagramEditContext)

  const getConnectorPins = async (section) => {
    navDispatch({
      type: 'loader',
      data: {
        caption: `Fetching Circuit Pins Details`,
        showLoader: true,
      },
      notification: {},
    })
    let url = `/api/vehicles/component-search/${vehicle}/?connector=${section.name}&is_connector=true`
    if (state?.selectedSection?.type == 'devices') {
      url = `/api/vehicles/component-search/${vehicle}/?device=${section.name}`
    }
    let res = await getRequest(url)
    dispatch({
      type: SET_SELECTED_SECTION_RECORD_DATA,
      data: { ...section, data: res?.data },
    })

    navDispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  return (
    <>
      <div className="w-full">
        <div className="flex justify-center gap-0 text-base pt-2">
          <div
            className={`py-1 px-3 ${state?.selectedSection?.type == 'connectors' ? 'bg-white' : 'bg-tracer-lt-blue text-white'} cursor-pointer flex`}
            onClick={() => {
              dispatch({
                type: SET_SELECTED_SECTION_DATA,
                data: { type: 'connectors', data: state?.data?.connectors },
              })
            }}
          >
            {state?.isSearching ? (
              <ProgresSpinner caption="" />
            ) : (
              state?.data?.connectors?.length
            )}{' '}
            Connector{' '}
            {state?.selectedSection?.type == 'connectors' && (
              <span className="">&#x25B2;</span>
            )}
          </div>
          <div
            className={`py-1 px-3 ${state?.selectedSection?.type == 'devices' ? 'bg-white' : 'bg-tracer-lt-blue text-white'} cursor-pointer flex`}
            onClick={() => {
              dispatch({
                type: SET_SELECTED_SECTION_DATA,
                data: { type: 'devices', data: state?.data?.devices },
              })
            }}
          >
            {state?.isSearching ? (
              <ProgresSpinner caption="" />
            ) : (
              state?.data?.devices?.length
            )}{' '}
            Device{' '}
            {state?.selectedSection?.type == 'devices' && (
              <span className="">&#x25B2;</span>
            )}
          </div>
          <div
            className={`py-1 px-3 ${state?.selectedSection?.type == 'circuits' ? 'bg-white' : 'bg-tracer-lt-blue text-white'} cursor-pointer flex`}
            onClick={() => {
              dispatch({
                type: SET_SELECTED_SECTION_DATA,
                data: { type: 'circuits', data: state?.data?.circuits },
              })
            }}
          >
            {state?.isSearching ? (
              <ProgresSpinner caption="" />
            ) : (
              state?.data?.circuits?.length
            )}{' '}
            Circuit{' '}
            {state?.selectedSection?.type == 'circuits' && (
              <span className="">&#x25B2;</span>
            )}
          </div>
        </div>
        <div
          className="bg-white px-2"
          style={{ height: '60vh', overflowY: 'scroll' }}
        >
          {state?.selectedSection?.type == 'circuits' ? (
            <SearchCircuitHeader />
          ) : (
            <div className="font-semibold">
              <div className="flex flex-row w-full rounded-t-lg text-black text-sm border-b border-gray-500 py-2">
                <div className="flex w-1/12 pl-1 items-center"></div>
                <div className="flex w-3/12 pl-2 items-center">ID</div>
                <div className="flex w-3/12 pl-6 items-center">Alias</div>
                <div className="flex w-5/12 pl-6 items-center">Description</div>
              </div>
            </div>
          )}

          <div style={{ maxHeight: '60vh', overflowY: 'scroll' }}>
            {state?.selectedSection?.data?.map((section, index) => {
              return state?.selectedSection?.type == 'circuits' ? (
                <SearchCircuitRows
                  {...section}
                  key={`gloabl-search-item-${index}`}
                  onSelect={() => {
                    getConnectorPins(section)
                  }}
                  selectedSectionRecord={state.selectedSectionRecord}
                />
              ) : (
                <SearchResultRows
                  {...section}
                  key={`gloabl-search-item-${index}`}
                  onSelect={() => {
                    getConnectorPins(section)
                  }}
                  selectedSectionRecord={state.selectedSectionRecord}
                />
              )
            })}

            {state?.isSearching ? (
              <div className="flex justify-center py-6 items-center">
                <ProgresSpinner caption="Searching In Progress" />
              </div>
            ) : (
              state?.selectedSection?.data?.length == 0 && <NoDataFound />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default SearchResult
